import { useEffect } from 'react';
import { useSystemConfiguration } from '@/api/system-configuration/use-system-configuration';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Component that dynamically sets the favicon based on system configuration.
 * On trader pages, uses trader_favicon_url when set; otherwise uses the general system favicon.
 */
export const FaviconSetter: React.FC = () => {
    const { data: config } = useSystemConfiguration();
    const { detectedUserType, isTrader } = useAuth();

    useEffect(() => {
        let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

        if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            document.head.appendChild(faviconLink);
        }

        const generalFavicon = config?.system_favicon_url || config?.favicon_url;
        const faviconUrl =
            isTrader() && config?.trader_favicon_url ? config.trader_favicon_url : generalFavicon;

        if (faviconUrl) {
            faviconLink.href = faviconUrl;
            faviconLink.type = faviconUrl.endsWith('.svg')
                ? 'image/svg+xml'
                : faviconUrl.endsWith('.ico')
                  ? 'image/x-icon'
                  : 'image/png';
        } else {
            faviconLink.remove();
        }
    }, [
        detectedUserType,
        config?.system_favicon_url,
        config?.favicon_url,
        config?.trader_favicon_url,
    ]);

    return null;
};
